import styled from "styled-components";

export const Container = styled.section`
    max-width: 960px;
    margin: 20px auto;
    box-shadow: 0 0 1em #6c757d;
    padding: 20px;
`;
export const ButtonPrimary = styled.button`
    background-color:#fff;
    color: #3e3e3e;
    padding: 5px 8px;
    border-radius:4px;
    cursor: pointer;
    font-size:14px;
    :hover{
        background-color:#0d6efd;
        color:#fff;
    }
`;

export const ConteudoProd = styled.p`
    color: #3e3e3e;
    font-size: 16px
`
